<div class="row">
  <div class="col">
    <h4 class="mb-3">Dados do cartão de crédito</h4>
  </div>
</div>
<div class="row mt-2">
  <div class="col">
    <label for="nome">Nome</label>
    <input
      [(ngModel)]="creditCard.nome"
      placeholder="Nome completo, como mostrado no cartão"
      name="nome"
      type="text"
      class="form-control"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
    />
    <!-- <small class="text-muted">Nome completo, como mostrado no cartão.</small> -->
    <div class="invalid-feedback">O nome que está no cartão é obrigatório.</div>
  </div>
</div>
<div class="row mt-2">
  <div class="col">
    <label for="numero">Número</label>
  </div>
</div>
<div class="row">
  <div class="col">
    <input
      [(ngModel)]="creditCard.numero1"
      type="text"
      class="form-control"
      id="numero"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
      (change)="change()"
    />
    <div class="invalid-feedback">
      O número do cartão de crédito é obrigatório.
    </div>
  </div>
  <div class="col">
    <input
      [(ngModel)]="creditCard.numero2"
      type="text"
      class="form-control"
      id="numero"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
      (change)="change()"
    />
    <div class="invalid-feedback">
      O número do cartão de crédito é obrigatório.
    </div>
  </div>
  <div class="col">
    <input
      [(ngModel)]="creditCard.numero3"
      type="text"
      class="form-control"
      id="numero"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
      (change)="change()"
    />
    <div class="invalid-feedback">
      O número do cartão de crédito é obrigatório.
    </div>
  </div>
  <div class="col">
    <input
      [(ngModel)]="creditCard.numero4"
      type="text"
      class="form-control"
      id="numero"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
      (change)="change()"
    />
    <div class="invalid-feedback">
      O número do cartão de crédito é obrigatório.
    </div>
  </div>
</div>
<div class="row mt-2">
  <div class="col">
    <label for="validadeMes">Validade - Mês</label>
    <select
      [(ngModel)]="creditCard.validadeMes"
      class="form-control"
      value="{{ creditCard.validadeMes }}"
      id="validadeMes"
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
    >
      <option *ngFor="let mes of this.meses" [value]="mes">{{ mes }}</option>
    </select>
  </div>
  <div class="col">
    <label for="validadeAno">Validade - Ano</label>
    <select
      [(ngModel)]="creditCard.validadeAno"
      class="form-control"
      value="{{ creditCard.validadeAno }}"
      id="validadeAno"
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
    >
      <option *ngFor="let ano of this.anos" [value]="ano">{{ ano }}</option>
    </select>
  </div>
  <div class="col">
    <label for="codigoSeguranca">CVV</label>
    <input
      [(ngModel)]="creditCard.codigoSeguranca"
      type="number"
      class="form-control"
      id="codigoSeguranca"
      required
      disabled="{{ !this.HabilitarEdicaoCampos() }}"
    />
    <div class="invalid-feedback">Código de segurança é obrigatório.</div>
  </div>
</div>

<div class="row mt-2">
  <div class="col">
    <div
      *ngIf="this.HabilitarMensagemAutorizando()"
      class="alert alert-primary"
      role="alert"
    >
      Processando... <span class="spinner-border spinner-border-sm"></span>
    </div>
    <div
      *ngIf="this.HabilitarMensagemRetorno()"
      [ngClass]="
        this.HabilitarMensagemRetorno() && paymentReturn && paymentReturn.sucess
          ? 'alert alert-success'
          : 'alert alert-danger'
      "
      role="alert"
    >
      {{ paymentReturn.status }}
    </div>
  </div>
</div>

<div *ngIf="this.HabilitarBotaoAutorizar()" class="row mt-2 mb-2">
  <div class="col">
    <button (click)="Save()" class="btn btn-primary">
      <i class="icofont-check-circled"></i>Autorizar
    </button>
  </div>
</div>
